import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './core/_layoutComponents/footer/footer.component';
import { BreadcrumbComponent } from './core/_layoutComponents/breadcrumb/breadcrumb.component';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import {
  ExcelModule,
  GridModule,
  PDFModule,
} from '@progress/kendo-angular-grid';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { LabelModule } from '@progress/kendo-angular-label';
import { PopupModule } from '@progress/kendo-angular-popup';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { CommonModule, CurrencyPipe, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientJsonpModule, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LayoutModule } from '@progress/kendo-angular-layout';
import 'hammerjs';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { DialogModule, DialogsModule } from '@progress/kendo-angular-dialog';
import { PrimeNgModule } from './core/library/prime-ng/prime-ng.module';
import { KendoModule } from './core/library/kendo/kendo.module';

import { NotifyComponent } from './shared/components/notify/notify.component';
import { CookieService } from 'ngx-cookie-service';

import { NgxPaginationModule } from 'ngx-pagination'; // <-- import the ngx pagination
import {
  UploadModule,
  FileSelectDirective
} from '@progress/kendo-angular-upload';

import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { TooltipModule } from '@progress/kendo-angular-tooltip';

import { InfoComponent } from './shared/components/info/info.component';

import { CaPropComponent } from './shared/components/ca-prop/ca-prop.component';

import { SampleRequestAdminComponent } from './features/admin/sample-request-admin/sample-request-admin.component';

import { AuthInterceptor } from './core/interceptors/auth.interceptor';


import { SampleRequestNewComponent } from './features/sample-request/sample-request-new.component';//needed
import { LoginComponent } from './features/admin/login/login.component';//needed
import { HomeComponent } from './features/admin/home/home.component';//needed



import { ImageLoaderDirective } from './core/directives/image-loader.directive';
import { StopWheelDirective} from './core/directives/kendo-numerictextbox-stop-wheel.directive';
import { InchValidateDirective } from './core/directives/inch-validator.directive';

import { UnauthorizedComponent } from './features/unauthorized/unauthorized.component';

import { LoggedInHeaderComponent } from './core/_layoutComponents/header/logged-in-header/logged-in-header.component';

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

import { environment } from '../environments/environment';


import { NumericTextBoxComponent } from './shared/components/numeric-text-box/numeric-text-box.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { InputValidatorDirective } from './core/directives/input-validator.directive';

import { SampleRequestOrderHistoryComponent } from './features/admin/sample-request-order-history/sample-request-order-history.component';
import { SampleRequestOrderDetailsComponent } from './features/admin/sample-request-order-details/sample-request-order-details.component';
import { SampleRequestInventoryUsageReportComponent } from './features/admin/sample-request-inventory-usage-report/sample-request-inventory-usage-report.component';
import { SampleRequestReorderReportComponent } from './features/admin/sample-request-reorder-report/sample-request-reorder-report.component';
import { SampleRequestUsageReportComponent } from './features/admin/sample-request-usage-report/sample-request-usage-report.component';
import { AdminBudgetReportComponent } from './features/admin/sample-request-admin/admin-budget-report/admin-budget-report.component';
import { BudgetReportComponent } from './features/admin/sample-request-admin/admin-budget-report/budget-report/budget-report.component';
import { AllocationReportComponent } from './features/admin/sample-request-admin/admin-budget-report/allocation-report/allocation-report.component';

import { ChangePasswordComponent } from './features/change-password/change-password.component';


@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    BreadcrumbComponent,  
    NotifyComponent,    
    InfoComponent,    
    CaPropComponent,
    
    SampleRequestAdminComponent,  
    SampleRequestNewComponent, 
    
    ImageLoaderDirective,
    StopWheelDirective,
    InchValidateDirective,
    
    UnauthorizedComponent,
    
    LoggedInHeaderComponent,   
    
    NumericTextBoxComponent,
    InputValidatorDirective,
    
    SampleRequestOrderHistoryComponent,
    SampleRequestOrderDetailsComponent,
    SampleRequestInventoryUsageReportComponent,
    SampleRequestReorderReportComponent,
    SampleRequestUsageReportComponent,
    AdminBudgetReportComponent,
    BudgetReportComponent,
    AllocationReportComponent,
    
    ChangePasswordComponent,
    LoginComponent,
    HomeComponent

    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ButtonsModule,
    BrowserAnimationsModule,
    DropDownsModule,
    GridModule,
    NotificationModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    DropDownsModule,
    LabelModule,
    ButtonsModule,
    PopupModule,
    InputsModule,
    LayoutModule,
    GridModule,
    ChartsModule,
    PDFModule,
    ExcelModule,
    DialogModule,
    PrimeNgModule,
    KendoModule,
    DialogsModule,
    UploadModule ,
    NgxPaginationModule,
    IndicatorsModule,
    TooltipModule,
    NgIdleKeepaliveModule.forRoot(),   
  ],
  entryComponents: [NotifyComponent],
  exports: [PrimeNgModule, KendoModule],
  providers: [CookieService, {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
  }, CurrencyPipe,
    { provide: LocationStrategy, useClass: PathLocationStrategy }, DeviceDetectorService  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
